define('SageDotCom/Components/DynamicProductCard/DynamicProductModal',["jquery", "eventManager", "underscore", "SageDotCom/DataLayer/Events/product-card-detail", "SageDotCom/DataLayer/Events/DynamicProductModal", "SageDotCom/Utility/sanitizer"],
    function($, eventManager, _, ProductCardDetailEvent, ModalEvents, sanitizer) {
        // Define a global flag to enable or disable logging
        window.enableLogging = false;

        function DynamicProductModal(scope,
            isEditing,
            isPreview,
            sku,
            promoOverwrite,
            basePromoCodeOverwrite,
            promoBoxText,
            freeLabel,
            selectBoxTemplate,
            pricePostText,
            modalId,
            postPriceLabelText,
            extraText,
            promoPillFreeText,
            promoPillDiscountText,
            dayLabel,
            daysLabel,
            monthLabel,
            monthsLabel) {
            let modalGenerated = false;
            const allowedOrigin = window.location.origin; // Ensures same-origin redirection

            if ($(".dynamic-product-card-updater").length) {
                window.productCardUpdater_newPromo = promoOverwrite;
                eventManager.subscribe("productCardUpdated",
                    (newSku, newBasePromo) => {
                        sku = (newSku !== null && newSku !== undefined) ? newSku : sku;
                        basePromoCodeOverwrite = (newBasePromo !== null && newBasePromo !== undefined)
                            ? newBasePromo
                            : "";
                        promoOverwrite = (window.productCardUpdater_newPromo !== null &&
                                window.productCardUpdater_newPromo !== undefined)
                            ? window.productCardUpdater_newPromo
                            : promoOverwrite;
                        modalGenerated = false;
                    });
            }


            var locale = undefined;
            var currentUrl = undefined;

            promoOverwrite = promoOverwrite.trim();

            if (isEditing || isPreview) {
                currentUrl = new URL(window.location.href);
                locale = currentUrl.searchParams.get("sc_lang");
                log(`Locale is from sc_lang: ${locale}`);
            }

            if (locale === undefined) {
                const pathName = document.location.pathname;
                const localeArr = pathName.split("/");
                for (let i = 0; i < localeArr.length; i++) {
                    if (localeArr[i] !== "") {
                        locale = localeArr[i];
                        log(`Locale is from pathname (${pathName}): ${locale}`);
                        break;
                    }
                }
            }

            const addonClick = (newSku, useUpdater = false) => {
                const inputSku = (!newSku || typeof newSku !== "string" || newSku.trim() === "")
                    ? $(scope).find(".product-sku-input span[sc-part-of='field']").text()
                    : newSku;
                $(".product-indexes").empty();

                const $checkboxCrossSellArea = $(".dynamic-product-card-updater .checkboxCrossSellArea");
                const AddSpinner = ($element) => {
                    if ($element.length) {
                        $element.addClass("icon-loader icon-loader-black");
                    }
                }
                const RemoveSpinner = ($element) => {
                    if ($element.length) {
                        $element.removeClass("icon-loader icon-loader-black");
                    }
                }

                $.ajax({
                    type: "GET",
                    url: `/sitecore/api/product/BaseCrossSellForProduct/${inputSku}/${locale}`,
                    context: this
                }).done(function (response) {
                    var jsonObj = JSON.parse(response);
                    if (jsonObj === null) {
                        console.error("jsonObj was null - Stopping the treatment");
                        if (useUpdater) {
                            $(".dynamic-product-card-updater .promo-overwrite-container").empty();
                            RemoveSpinner($checkboxCrossSellArea);
                            $(".dynamic-product-card-updater .checkboxCrossSell").prop("checked", false);
                        }
                        return;
                    }

                    var productIndexesContainer = $(".product-indexes");
                    var promoOverwriteContainer = $(".promo-overwrite-container");
                    const promoBtnContainer = $(".promo-overwrite-btn-container");
                    $(".promo-overwrite-helptext").removeClass("hidden");

                    let newPromosArray = [];
                    if (useUpdater) {
                        const existingCrossSellPromos = window.productCardUpdater_newPromo
                            ? window.productCardUpdater_newPromo
                            : "";
                        newPromosArray = existingCrossSellPromos.split("-");
                        AddSpinner($checkboxCrossSellArea);
                    }

                    jsonObj.forEach(function(product, i) {
                        const variantInfoObj = $("<div>").addClass("product-index")
                            .html(`${i} is for variant${i > 0 ? "s" : ""}: ${getProductNames(jsonObj, i)}`);
                        const promoWrapper = document.createElement("div");

                        if (useUpdater && newPromosArray.length === jsonObj.length) {
                            promoWrapper.innerHTML = `
                                        <div class="promo-overwrite-wrapper">
                                            <label>${product.Name}</label>
                                            <input type="text" class="promo-input" placeholder="Enter promo code" value="${
                                newPromosArray[i]}" >
                                        </div>
                                    `;
                        } else {
                            promoWrapper.innerHTML = `
                              <div class="promo-overwrite-wrapper">
                                <label class="score-editField">${product.BundleSku}</label>
                                <input type="text" class="promo-input" placeholder="Enter promo code">
                              </div>
                            `;
                        }

                        if (promoOverwriteContainer.length > 0) {
                            promoOverwriteContainer.append(promoWrapper);
                        }
                        if (productIndexesContainer.length > 0) {
                            productIndexesContainer.append(variantInfoObj);
                        }
                    });

                    if (useUpdater) {
                        RemoveSpinner($checkboxCrossSellArea);
                    }

                    var hiddenInput = $(".promo-overwrite-input span[contenteditable='true']");
                    const combineButton = $("<button>").addClass("score-button").text("Combine Inputs");

                    // Add an event listener to the button
                    combineButton.on("click",
                        function() {
                            const combinedValues = $(".promo-input").map(function() {
                                const value = $(this).val(); // Get the input value
                                return value;
                            }).get();

                            // Combine label-value pairs with "|" separator
                            const combinedValue = combinedValues.join("-");

                            // Inject the combined value into the hidden input field
                            hiddenInput.text(combinedValue);
                        });

                    // Append the button and hidden input
                    if (promoBtnContainer.length > 0) {
                        promoBtnContainer.append(combineButton);
                    }

                    function getProductNames(products, index) {
                        return products.slice(0, index + 1).map(product => product.Name).join(", ");
                    }
                });

            }

            if ($(".dynamic-product-card-updater").length) {
                eventManager.subscribe("productCardCrossSellUpdated",
                    (newSku, useUpdater) => addonClick(newSku, useUpdater));
            }

            if (isEditing) {
                const addonCheckButton = $(".cross-sell-check", scope);


                addonCheckButton.on("click", addonClick);
            } else {
                const $button = $(".score-button.modal-launch-btn", scope);
                const $modal = $(".modal", scope);
                const $modalDialog = $(".modal-dialog", $modal);
                const $leftSide = $(".left-side-section", $modal);
                const $rightSide = $(".right-side-section", $modal);
                const $modalContentHeaderTitle = $leftSide.find(".section-header-section .score-section-header h2");
                const modalTitle = $modalContentHeaderTitle.text().trim();
                const $modalContent = $(".modal-content", $modal);
                const $noThanksButton = $(".non-addon-button-section .score-button", $modal);
                const $addonsSection = $(".addons", $modal);
                const addonTemplate = $addonsSection.find(".addon[data-addon-sku='Template']").get(0);
                const $confirmSection = $(".confirm-section", $modal);
                const $confirmSelectionButtonTemplate = $confirmSection.find(".confirm-template");
                const promoTemplateOld =
                    $(addonTemplate).find(".sage-dynamic-modal-product-card-promotion-banner").text();
                const promoTemplate = promoBoxText;
                const $dropdownLabel = $(".dropdown-label", $modal);
                const dropdownLabelTemplate = $dropdownLabel.attr("data-template");
                const $radioButtonSection = $(".radio-buttons-section", $modal);
                const selectionTemplate = $radioButtonSection.find("label[for='template']");
                //If no template provided, go with the default
                if (selectBoxTemplate.trim() === "") {
                    if ($modal.hasClass("display-discount-number")) {
                        selectBoxTemplate =
                            '<span class="product-name">[product-name]</span>&nbsp; <span class="price">[discount-price][pricePostText]</span>';
                    } else if ($modal.hasClass("display-discount-text")) {
                        selectBoxTemplate =
                            '<span class="product-name">[product-name]</span>&nbsp; <span class="price">[discount-price-text]</span>';
                    } else if ($modal.hasClass("display-discount-and-rrp")) {
                        selectBoxTemplate =
                            '<span class="product-name">[product-name]</span>&nbsp; <del class="demoted-price">[rrp]</del>&nbsp; <span class="price">[discount-price][pricePostText]</span>';
                    } else if ($modal.hasClass("display-rrp-text")) {
                        selectBoxTemplate =
                            '<span class="product-name">[product-name]</span>&nbsp; <span class="price">[rrp-text][pricePostText]</span>';
                    } else {
                        selectBoxTemplate =
                            '<span class="product-name">[product-name]</span>&nbsp; <span class="price">[rrp][pricePostText]</span>';
                    }
                }

                selectBoxTemplate = selectBoxTemplate.replace("[pricePostText]", pricePostText);

                //For radio button selection templates

                let radioButtonTemplate;

                if ($modal.hasClass("display-discount-number")) {
                    radioButtonTemplate =
                        '<span class="selection-price"><strong class="price-value">[discount-price]</strong>[pricePostText]</span>';
                } else if ($modal.hasClass("display-discount-text")) {
                    radioButtonTemplate =
                        '<span class="selection-price"><strong class="price-value">[discount-price-text]</strong></span>';
                } else if ($modal.hasClass("display-discount-and-rrp")) {
                    radioButtonTemplate =
                        '<span class="selection-price"><del class="demoted-price">[rrp]</del>&nbsp;<strong class="price-value">[discount-price]</strong>[pricePostText]</span>';
                } else if ($modal.hasClass("display-rrp-text")) {
                    radioButtonTemplate =
                        '<span class="selection-price"><strong class="price-value">[rrp-text]</strong>[pricePostText]</span>';
                } else {
                    radioButtonTemplate =
                        '<span class="selection-price"><strong class="price-value">[rrp]</strong>[pricePostText]</span>';
                }

                radioButtonTemplate = radioButtonTemplate.replace("[pricePostText]", postPriceLabelText);

                //Remove the modal & append to body for styling
                $modal.detach();
                $("body").append($modal);

                let $targetParentId;
                let focusableElements;
                let firstElement;
                let lastElement;
                let prevFocusableElement;

                let resizeTimeout;

                const fallBackHref = $button.attr("data-href").replace("{locale}", locale);
                $button.attr("data-href", fallBackHref);

                const resizeFunc = () => {
                    window.clearTimeout(resizeTimeout);

                    const maxHeight = $modalDialog.innerHeight();
                    const windowWidth = $(window).width();

                    $leftSide.height("auto");
                    $rightSide.height("auto");
                    $modalContent.height("auto");

                    //Catch to ensure the calculations will be valid
                    if ($leftSide.outerHeight() > 0 && $rightSide.outerHeight() > 0) {
                        let targetHeight = 0;
                        targetHeight = $leftSide.outerHeight();
                        if (windowWidth < 1080) {
                            targetHeight += $rightSide.outerHeight();
                        } else if ($rightSide.outerHeight() > targetHeight) {
                            targetHeight = $rightSide.outerHeight();
                        }

                        if (maxHeight < targetHeight) {
                            targetHeight = maxHeight;
                        }

                        if (windowWidth >= 1080) {
                            $leftSide.outerHeight(`${targetHeight}px`);
                            $rightSide.outerHeight(`${targetHeight}px`);
                        }

                        $modalContent.height(`${targetHeight}px`);
                    }
                };

                function isValidInternalUrl(url) {
                    try {
                        const parsedUrl = new URL(url, window.location.origin);
                        return parsedUrl.origin === window.location.origin;
                    } catch (e) {
                        return false;
                    }
                }

                eventManager.subscribe(`select-drop-down-option-selected-${modalId}`,
                    function (obj) {
                        const selectedSku = obj.identifier;
                        const validIndex = obj.index;
                        const selectedAddon = $addonsSection.find(`.addon[data-addon-sku='${selectedSku}']`);
                        const unselectedAddon = $addonsSection.find(`.addon[data-addon-sku!='${selectedSku}']`);
                        unselectedAddon.hide();
                        selectedAddon.show();

                        const features = $(".features .feature", $modal);
                        features.each(function (i, el) {
                            const thisIndex = $(el).attr("data-valid-index");
                            if (thisIndex <= validIndex) {
                                $(el).addClass("included");
                            } else {
                                $(el).removeClass("included");
                            }
                        });

                        const bundleSku = selectedAddon.attr("data-bundle-sku");
                        const promoCode = selectedAddon.attr("data-promocode");
                        //Trigger view event
                        triggerProductCardDetailEvent(bundleSku,
                            sku,
                            promoCode,
                            locale);

                        resizeFunc();
                    });

                const updateRadioButton = () => {
                    const selectedRadioBtn = $("input[type='radio']:checked", $modal);
                    const selectedRadioSku = selectedRadioBtn.attr("id");
                    const selectedConfirmBtn = $confirmSection.find(`div[class='confirm-${selectedRadioSku}']`);
                    const unselectedConfirmBtn = $confirmSection.find(`div[class!='confirm-${selectedRadioSku}']`);
                    unselectedConfirmBtn.hide();
                    selectedConfirmBtn.show();

                    const validIndex = $("input[type='radio']:checked", $modal).attr("data-index");

                    const features = $(".features .feature", $modal);
                    features.each(function (i, el) {
                        const thisIndex = $(el).attr("data-valid-index");
                        if (thisIndex <= validIndex) {
                            $(el).addClass("included");
                        } else {
                            $(el).removeClass("included");
                        }
                    });

                    // where we set the confirm selection url on radio button changes
                    const buyUrl = $("input[type='radio']:checked", $modal).attr("data-buy-url");
                    if (buyUrl && isValidInternalUrl(buyUrl)) {
                        selectedConfirmBtn.attr("href", buyUrl);
                    }
                    

                    //update promo-details section
                    const $promoDetails = $radioButtonSection.find(".promo-details");
                    $promoDetails.text($("input[type='radio']:checked", $modal).attr("data-promo"));
                    
                    //Trigger view event
                    const productSku = selectedRadioBtn.attr("product-sku");
                    const bundleSku = selectedRadioBtn.attr("bundle-sku");
                    const promoCode = selectedRadioBtn.attr("promo-code");
                    triggerProductCardDetailEvent(bundleSku,
                        sku,
                        promoCode,
                        locale);
                };

                $radioButtonSection.on("change", updateRadioButton);

                function addSpinner(context) {
                    context.addClass("icon-loader icon-loader-black");
                }

                function removeSpinner(context) {
                    context.removeClass("icon-loader icon-loader-black");
                }

                $(window).on("resize", function () {
                    clearTimeout(resizeTimeout);
                    resizeTimeout = window.setTimeout(resizeFunc, 50);
                });

                function replacePromoPeriod(promoText, periodType, periodLength) {

                    function pluralOrSingular(value, plural, singular) {
                        return value === 1 ? singular : plural;
                    }

                    const promoPeriodType = periodType.toLowerCase();
                    if (promoPeriodType === "month") {
                        promoText = promoText.replace("[promoPeriod]", pluralOrSingular(periodLength, monthsLabel, monthLabel));
                    }
                    else if (promoPeriodType === "day") {
                        promoText = promoText.replace("[promoPeriod]", pluralOrSingular(periodLength, daysLabel, dayLabel));
                    }

                    return promoText;
                }

                setTimeout(function () {
                        $button.on("click keydown",
                            function(e) {
                                const isClick = e.type === "click";
                                const isEnter = e.key === "Enter" || e.keyCode === 13;
                                const isSpace = e.key === " " || e.keyCode === 32;

                                if (!isClick && !isEnter && !isSpace) return;

                                if (isClick || isEnter || isSpace) e.preventDefault();


                                if (!modalGenerated) {
                                    log("Modal not generated, making AJAX call...");
                                    addSpinner($button);
                                    $.ajax({
                                            type: "GET",
                                            url: `/sitecore/api/product/DynamicProductCardModalData/${sku}/${locale}`,
                                            data: {
                                                promoCodeOverwrite: promoOverwrite,
                                                basePromoCodeOverwrite: basePromoCodeOverwrite,
                                                promoHtmlTemplate: sanitizer.sanitizeHtml(promoTemplate)
                                            },
                                            context: this,
                                            success: function(response) {
                                                log("AJAX call successful");
                                                const jsonObj = JSON.parse(response);
                                                log("Received JSON response:");
                                                log(jsonObj);

                                                if ($leftSide.find(".radio-buttons-section").length > 0) {

                                                    var $confirmSelectionButton =
                                                        $confirmSection.find(`.confirm-${jsonObj.SKU} .score-button`);

                                                    if ($confirmSelectionButton.length > 0) {
                                                        let href = jsonObj.BuyUrl;
                                                        $confirmSelectionButton.attr("data-buy-url", href);
                                                        $confirmSelectionButton.attr("href", href);
                                                        $confirmSelectionButton.attr("id",
                                                            `${modalId}-confirm-${jsonObj.SKU}`);
                                                        if (href && isValidInternalUrl(href)) {
                                                            $confirmSelectionButton.on("click",
                                                                function(e) {
                                                                    e.preventDefault();

                                                                    var buttonText = $(this).text().trim();
                                                                    new ModalEvents("pop_up_window_click",
                                                                            modalTitle,
                                                                            buttonText)
                                                                        .trigger();

                                                                    const redirectToURL = () => {
                                                                        location.href = href;
                                                                    };
                                                                    if (href.includes("sku=")) {
                                                                        const productService =
                                                                            new ProductCardDetailEvent();
                                                                        productService.triggerAddToCartTealiumEvent(
                                                                            href,
                                                                            $(this),
                                                                            "Popup",
                                                                            redirectToURL);
                                                                    } else {
                                                                        redirectToURL();
                                                                    }
                                                                });
                                                        }

                                                    }
                                                    //add baseurl to radio input
                                                    const noThanksRadioButton = $("input[type='radio'][name='" +
                                                        jsonObj.SKU +
                                                        "-product_selection']");
                                                    noThanksRadioButton.attr("data-buy-url", jsonObj.BuyUrl);

                                                    $(jsonObj.Products).each(function(i, product) {

                                                        const labelObj = $(selectionTemplate).clone();
                                                        const inputObj = $(labelObj).find("input");
                                                        const selectionName = $(labelObj).find("span.selection-name");
                                                        const selectionLabel = $(labelObj).find("p.selection-label");

                                                        $(labelObj).show();
                                                        $(labelObj).attr("for", `${jsonObj.SKU}-${product.SKU}`);

                                                        $(inputObj).attr("id", `${jsonObj.SKU}-${product.SKU}`);
                                                        $(inputObj).attr("name", `${jsonObj.SKU}-product_selection`);
                                                        $(inputObj).attr("data-index", i);
                                                        $(inputObj).attr("product-sku", product.SKU);
                                                        $(inputObj).attr("bundle-sku", product.BundleSku);

                                                        let selectionPriceHtml = radioButtonTemplate;
                                                        selectionPriceHtml =
                                                            selectionPriceHtml.replace("[rrp]",
                                                                `${product.FormattedRRPPrice} `);

                                                        //set promo pill text
                                                        var promoPillText;

                                                        let promoCode = undefined;
                                                        if (product.Promo) {
                                                            var value = product.Promo.Value;
                                                            if (product.Promo.DiscountedPrice === 0) {
                                                                promoPillText =
                                                                    promoPillFreeText.replace("[promoLength]",
                                                                        product.Promo.Length);
                                                            } else {
                                                                promoPillText =
                                                                    promoPillDiscountText.replace("[promoValue]",
                                                                        value);
                                                                promoPillText =
                                                                    promoPillText.replace("[promoLength]",
                                                                        product.Promo.Length);
                                                            };

                                                            promoPillText = replacePromoPeriod(promoPillText, product.Promo.LengthType, product.Promo.Length);

                                                            promoCode = product.Promo.PromoCode;
                                                            const $promoDetails =
                                                                $radioButtonSection.find(".promo-details");
                                                            $promoDetails.text(promoPillText);

                                                            $(inputObj).attr("promo-code", promoCode);
                                                        } else if (jsonObj.Products.length === (i + 1)) {

                                                            //no products have promos so remove promo pill
                                                            const $promoDetails =
                                                                $radioButtonSection.find(".promo-details");
                                                            $promoDetails.remove();
                                                        }

                                                        $(inputObj).attr("data-promo", promoPillText);

                                                        if (product.Promo) {
                                                            //Pricing logic
                                                            if ($modal.hasClass("display-discount-number") ||
                                                                $modal.hasClass("display-discount-text") ||
                                                                $modal.hasClass("display-discount-and-rrp")) {

                                                                if ($modal.hasClass("display-discount-text") &&
                                                                    product.Price === 0) {
                                                                    selectionPriceHtml =
                                                                        selectionPriceHtml.replace("[discount-price]",
                                                                            `${product.FormattedPrice} ${extraText} `);
                                                                    selectionPriceHtml =
                                                                        selectionPriceHtml.replace(
                                                                            "[discount-price-text]",
                                                                            freeLabel);
                                                                } else {
                                                                    selectionPriceHtml =
                                                                        selectionPriceHtml.replace("[discount-price]",
                                                                            `${product.FormattedPrice} ${extraText} `);
                                                                    selectionPriceHtml =
                                                                        selectionPriceHtml.replace(
                                                                            "[discount-price-text]",
                                                                            `${product.FormattedPrice} ${extraText} `);
                                                                }
                                                            } else {
                                                                // must be default of display rrp chosen
                                                                if ($modal.hasClass("display-rrp-text") &&
                                                                    product.Price === 0) {
                                                                    selectionPriceHtml =
                                                                        selectionPriceHtml.replace("[rrp-text]",
                                                                            freeLabel);
                                                                } else {
                                                                    totalPrice = product.FormattedBundlePrice;
                                                                    selectionPriceHtml = selectionPriceHtml.replace(
                                                                        "[rrp-text]",
                                                                        `${product.FormattedPrice} ${extraText}`);
                                                                }
                                                            }
                                                        } else {
                                                            //no promo
                                                            if ($modal.hasClass("display-rrp-text") &&
                                                                product.Price === 0) {
                                                                selectionPriceHtml =
                                                                    selectionPriceHtml.replace("[rrp-text]", freeLabel);
                                                            } else {
                                                                selectionPriceHtml = selectionPriceHtml.replace(
                                                                    "[rrp-text]",
                                                                    `${product.FormattedPrice} ${extraText}`);
                                                            }
                                                        }

                                                        //create confirm selection button for crossell variant
                                                        let $customConfirmButton =
                                                            $confirmSelectionButtonTemplate.clone();
                                                        $customConfirmButton.removeClass("confirm-template");
                                                        $customConfirmButton.addClass(
                                                            `confirm-${jsonObj.SKU}-${product.SKU}`);
                                                        $customConfirmButton.attr("data-buy-url", product.BundleBuyUrl);
                                                        $confirmSection.append($customConfirmButton);
                                                        let href = product.BundleBuyUrl;
                                                        if (href && isValidInternalUrl(href)) {
                                                            $customConfirmButton.find('.button-checkout')
                                                                .attr("id", `${modalId}-confirm-${jsonObj.SKU}-${product.SKU}`)
                                                                .attr("href", href).on("click",
                                                                    function(e) {
                                                                        // do not allow going to cart until events have fired
                                                                        e.preventDefault();

                                                                        var buttonText = $(this).text().trim();
                                                                        new ModalEvents("pop_up_window_click",
                                                                            modalTitle,
                                                                            buttonText).trigger();

                                                                        const redirectToURL = () => {
                                                                            location.href = href;
                                                                        };
                                                                        if (href.includes("sku=")) {
                                                                            const productService =
                                                                                new ProductCardDetailEvent();
                                                                            productService.triggerAddToCartTealiumEvent(
                                                                                href,
                                                                                $(this),
                                                                                "Popup",
                                                                                redirectToURL);
                                                                        } else {
                                                                            redirectToURL();
                                                                        }
                                                                    });
                                                        }

                                                        selectionName.text(`Yes, add ${product.Name}`);
                                                        selectionLabel.append(selectionPriceHtml);

                                                        $radioButtonSection.append(labelObj);
                                                    });
                                                    $(selectionTemplate).remove();
                                                    $confirmSelectionButtonTemplate.remove();
                                                } else if ($leftSide.find(".dropdown-section").length > 0) {
                                                    if ($noThanksButton !== undefined && $noThanksButton.length > 0) {
                                                        let href = jsonObj.BuyUrl;
                                                        $noThanksButton.attr("href", href);
                                                        $noThanksButton.attr("id", `${modalId}-no-thanks-${sku}`);
                                                        if (href && isValidInternalUrl(href)) {
                                                            $noThanksButton.on("click",
                                                                function(e) {
                                                                    e.preventDefault();

                                                                    var buttonText = $(this).text().trim();
                                                                    new ModalEvents("pop_up_window_click",
                                                                            modalTitle,
                                                                            buttonText)
                                                                        .trigger();

                                                                    const redirectToURL = () => {
                                                                        location.href = href;
                                                                    };
                                                                    if (href.includes("sku=")) {
                                                                        const productService =
                                                                            new ProductCardDetailEvent();
                                                                        productService.triggerAddToCartTealiumEvent(
                                                                            href,
                                                                            $(this),
                                                                            "Popup",
                                                                            redirectToURL);
                                                                    } else {
                                                                        redirectToURL();
                                                                    }
                                                                });
                                                        }
                                                    }

                                                    $dropdownLabel.text(
                                                        dropdownLabelTemplate.replace("[productName]",
                                                            jsonObj.FamilyName));
                                                    $addonsSection.find(".addon[data-addon-sku!='Template']").remove();

                                                    let firstProductOption = undefined;
                                                    let dropDownData = [];
                                                    $(jsonObj.Products).each(function(i, product) {
                                                        //Select box logic
                                                        let innerLinkHtml = selectBoxTemplate;
                                                        innerLinkHtml =
                                                            innerLinkHtml.replace("[product-name]", product.Name);
                                                        innerLinkHtml =
                                                            innerLinkHtml.replace("[rrp]", product.FormattedRRPPrice);

                                                        if (i === 0) {
                                                            firstProductOption = product.SKU;
                                                        }

                                                        const $detailsObj = $(addonTemplate).clone();
                                                        $detailsObj.attr("data-addon-sku", product.SKU);
                                                        $detailsObj.attr("data-bundle-sku", product.BundleSku);

                                                        if (product.PriceDemoted ||
                                                            $modal.hasClass("display-discount-and-rrp")) {
                                                            $detailsObj.find(".demoted-price")
                                                                .text(product.FormattedRRPBundlePrice);
                                                        }

                                                        let promoCode = undefined;
                                                        let totalPrice = undefined;

                                                        if (product.Promo) {
                                                            log("addonTemplate:");
                                                            log(addonTemplate);
                                                            log("promoTemplate:");
                                                            log(promoTemplate);
                                                            log("promoTemplateOld:");
                                                            log(promoTemplateOld);
                                                            log("$detailsObj:");
                                                            log($detailsObj);
                                                            log("$detailsObj banner:");
                                                            log($detailsObj.find(
                                                                ".sage-dynamic-modal-product-card-promotion-banner"));

                                                            log(product.Promo.Description);

                                                            const promotionBanner =
                                                                $detailsObj.find(
                                                                    ".sage-dynamic-modal-product-card-promotion-banner");
                                                            promotionBanner
                                                                .empty(); // Clear any existing content to prevent conflicts
                                                            product.Promo.PromoHtml =
                                                                sanitizer.sanitizeHtml(product.Promo.PromoHtml);
                                                            promotionBanner.append(product.Promo
                                                                .PromoHtml); // Append the HTML content

                                                            $detailsObj.find(".sage-dynamic-modal-product-card-promo")
                                                                .show();

                                                            promoCode = product.Promo.PromoCode;

                                                            $detailsObj.attr("data-promocode", promoCode);

                                                            //Pricing logic
                                                            if (product.PriceDemoted ||
                                                                $modal.hasClass("display-discount-number") ||
                                                                $modal.hasClass("display-discount-text") ||
                                                                $modal.hasClass("display-discount-and-rrp")) {

                                                                if ($modal.hasClass("display-discount-text") &&
                                                                    product.Price === 0) {
                                                                    totalPrice = freeLabel;
                                                                    innerLinkHtml = innerLinkHtml.replace(
                                                                        "[discount-price]",
                                                                        product.FormattedPrice);
                                                                    innerLinkHtml =
                                                                        innerLinkHtml.replace("[discount-price-text]",
                                                                            freeLabel);
                                                                } else {
                                                                    totalPrice = product.FormattedPrice;
                                                                    innerLinkHtml = innerLinkHtml.replace(
                                                                        "[discount-price]",
                                                                        product.FormattedPrice);
                                                                    innerLinkHtml = innerLinkHtml.replace(
                                                                        "[discount-price-text]",
                                                                        product.FormattedPrice);
                                                                }
                                                            } else {
                                                                // must be default of display rrp chosen
                                                                if ($modal.hasClass("display-rrp-text") &&
                                                                    product.Price === 0) {
                                                                    totalPrice = freeLabel;
                                                                    innerLinkHtml =
                                                                        innerLinkHtml.replace("[rrp-text]", freeLabel);
                                                                } else {
                                                                    totalPrice = product.FormattedBundlePrice;
                                                                    innerLinkHtml =
                                                                        innerLinkHtml.replace("[rrp-text]",
                                                                            product.FormattedPrice);
                                                                }
                                                            }
                                                        } else {
                                                            //no promo
                                                            if ($modal.hasClass("display-rrp-text") &&
                                                                product.Price === 0) {
                                                                totalPrice = freeLabel;
                                                                innerLinkHtml =
                                                                    innerLinkHtml.replace("[rrp-text]", freeLabel);
                                                            } else {
                                                                totalPrice = product.FormattedBundlePrice;
                                                                innerLinkHtml =
                                                                    innerLinkHtml.replace("[rrp-text]",
                                                                        product.FormattedRRPPrice);
                                                            }
                                                        }
                                                        log(totalPrice);


                                                        dropDownData.push(
                                                            { optionHtml: innerLinkHtml, identifier: product.SKU });
                                                        $detailsObj.find(".price").text(product.FormattedBundlePrice);
                                                        let href = product.BundleBuyUrl;
                                                        if (href && isValidInternalUrl(href)) {
                                                            $detailsObj.find(".button-checkout")
                                                                .attr("href", href)
                                                                .attr("id", `${modalId}-checkout-${sku}-${product.BundleSku}`)
                                                                .on("click",
                                                                    function(e) {
                                                                        // do not allow going to cart until events have fired
                                                                        e.preventDefault();

                                                                        var buttonText = $(this).text().trim();
                                                                        new ModalEvents("pop_up_window_click",
                                                                            modalTitle,
                                                                            buttonText).trigger();

                                                                        const redirectToURL = () => {
                                                                            location.href = href;
                                                                        };
                                                                        if (href.includes("sku=")) {
                                                                            const productService =
                                                                                new ProductCardDetailEvent();
                                                                            productService.triggerAddToCartTealiumEvent(
                                                                                href,
                                                                                $(this),
                                                                                "Popup",
                                                                                redirectToURL);
                                                                        } else {
                                                                            redirectToURL();
                                                                        }
                                                                    });
                                                        }


                                                        $addonsSection.append($detailsObj);
                                                    });

                                                    if (firstProductOption !== undefined) {
                                                        eventManager.trigger(
                                                            `select-drop-down-replace-options-${modalId}`,
                                                            { options: dropDownData });
                                                    }
                                                }

                                                modalGenerated = true;
                                                $modal.modal("show");
                                                removeSpinner($button);
                                            }
                                        })
                                        .fail(function (response) {
                                            log("AJAX call failed");
                                            removeSpinner($button);

                                            const url = new URL(fallBackHref, allowedOrigin);

                                            if (url.origin === allowedOrigin) {
                                                const redirectToURL = () => { location.href = fallBackHref; };
                                                if (fallBackHref.includes("sku=")) {
                                                    const productService = new ProductCardDetailEvent();
                                                    productService.triggerAddToCartTealiumEvent(fallBackHref,
                                                        $(this),
                                                        "Product Card",
                                                        redirectToURL);
                                                } else {
                                                    redirectToURL();
                                                }
                                            } else {
                                                log("Blocked potential untrusted redirection attempt.");
                                            }
                                        });
                                } else {
                                    log("Modal already generated, showing the modal...");
                                    $modal.modal("show");
                                }

                                $targetParentId = e.target.parentNode.id;
                            });

                        $modal.on("show.bs.modal",
                            function(e) {
                                $modal.attr("aria-hidden", false);
                                focusableElements = Array.from(e.target.querySelectorAll(
                                    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]):not(.chrome-ui-button):not(#chrome-url-bar), input[type="radio"]'));
                                prevFocusableElement = document.activeElement;
                                if (focusableElements != null && focusableElements.length > 0) {
                                    firstElement = focusableElements[0];
                                    lastElement = focusableElements[focusableElements.length - 1];
                                }
                                trapFocus(true, firstElement, lastElement, prevFocusableElement);
                            });

                        $modal.on("shown.bs.modal",
                            function(e) {
                                new ModalEvents("pop_up_window_display", modalTitle).trigger();
                                resizeFunc();
                            });

                        $modal.on("hidden.bs.modal",
                            function(e) {
                                if ($targetParentId) {
                                    const $targetBtnSelected = $("#" + $targetParentId + " .score-button");
                                    if ($targetBtnSelected) {
                                        $targetBtnSelected.focus();
                                        const $styleBox = $targetBtnSelected.parent().closest(".score-style-box");
                                        if ($styleBox)
                                            $styleBox.focus();
                                    }
                                    trapFocus(false, firstElement, lastElement, prevFocusableElement);
                                }
                                new ModalEvents("pop_up_window_close", modalTitle).trigger();
                                $modal.attr("aria-hidden", true);
                            });
                    },
                    250);
            }
        }

        function log(message) {
            if (window.enableLogging) {
                console.log("SAGE DEBUG: ", message);
            }
        }

        function trapFocus(isModalOpen, firstElement, lastElement, prevFocusableElement) {
            const handleFocus = e => {

                if (e.keyCode === 9) {
                    if (!e.shiftKey && $(e.target).is(lastElement)) {
                        e.preventDefault();
                        firstElement.focus();
                    } else if (e.shiftKey && $(e.target).is(firstElement)) {
                        e.preventDefault();
                        lastElement.focus();
                    }
                }
            };

            if (isModalOpen) {
                firstElement.focus();
                document.addEventListener("keydown", handleFocus, true);
            } else {
                document.removeEventListener("keydown", handleFocus, true);
                prevFocusableElement.focus();
            }
        }

        function triggerProductCardDetailEvent(addonSku, baseSku, addonPromoCode, locale) {
            const productService = new ProductCardDetailEvent();

            //Make call to tealium
            productService.productDetailEvent(addonSku, baseSku, addonPromoCode, locale, "modal window", true);
        }

        return function initDynamicProductModal(args) {
            return new DynamicProductModal(args.scope,
                args.isEditing,
                args.isPreview,
                args.sku,
                args.promoOverwrite,
                args.basePromoCodeOverwrite,
                args.promoBoxText,
                args.freeLabel,
                args.selectBoxTemplate,
                args.pricePostText,
                args.modalId,
                args.postPriceLabelText,
                args.extraText,
                args.promoPillFreeText,
                args.promoPillDiscountText,
                args.dayLabel,
                args.daysLabel,
                args.monthLabel,
                args.monthsLabel
            );
        };
    });
